import { isDetailedIncome } from "web_myplann/Finances/Helpers/isDetailedIncome";
import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";
import type { BalanceBreakdownEntry } from "web_myplann/Finances/Types/BalanceBreakdownEntry";

export const mapIncomeBreakdown = (
	income: FinanceState["income"],
): BalanceBreakdownEntry[] =>
	isDetailedIncome(income)
		? income.map((entry, index) => ({
				key: `${entry.id ?? "new"}-${index}`,
				label: entry.name,
				amount: entry.amount,
			}))
		: [];
